import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';

export default {
  name: 'performDisconnection',
  components: {

  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      appData: {
        connections: [],
        customDate: null,
        hasCustomDate: false
      },
      customDateView: null,
      lang: '',
      readOnly: false,
      selectedMeterId: -1
    }
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('perform_disconnection_updated', this.init);
    this.init();
  },
  watch: {
    customDateView: function (val) {
      this.appData.customDate = moment(val, "DD/MM/YYYY").add(1, 'days');
    }
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.appData = this.dataObj.appData;
        this.customDateView = this.$options.filters.formatDateDDMMYYY(this.appData.customDate);
        console.log(this.appData);
        this.readOnly = this.dataObj.readOnly;
      });
    },
    onSelect(item) {
      if (item == null)
        this.selectedMeterId = -1;
      else
        this.selectedMeterId = item.meterId;
    }
  },
}
